import { useState , useEffect } from 'react'
import styles from './styles.module.sass'


export default function HasFreeShipping(props){
    const {
        setToggleFreeSipping,
        resetFilters
    } = props

    const [ attribute , setAttribute ] = useState(false)
    const [ toggle , setToggle ] = useState(false)

    const handleToggle = () => {
        setToggle(!toggle)
    }

    useEffect(()=>{
        if(resetFilters){
            setToggle(false)
            setAttribute(false)
        }
    },[resetFilters])
    
    useEffect(()=>{
        if(toggle){
            setAttribute(true)
            setToggleFreeSipping(true)
        }else{
            setAttribute(false)
            setToggleFreeSipping(false)
        }
    },[toggle])

    return(
        <div className={styles?.seccionEnvioFiltros}>
            <div className={styles?.cajaEnvio}>
                <div className={styles?.cajaTexto}>
                    <p> ENVÍO GRATIS</p>
                </div>
                <div className={styles?.cajaSwitch}>
                    <label htmlFor="shipping">
                        <input
                            className={styles?.input}
                            type="checkbox"
                            checked={attribute === true}
                            onChange={ handleToggle }
                            id="shipping"
                        />
                        <div className={styles?.toggle}>
                            <span className={styles?.selector} />
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
}